'use strict';
import React from 'react';

export default class CheckoutPreviewAddress extends React.Component {
    render() {
        let data = this.props.cart.get('checkout').toJS();
        return (
            <div className="preview__address">
                <div className="address__headline">Zusammenfassung</div>
                <div className="address__items">

                    <div className="items__row">
                        <div className="row__title">Rechnungsadresse</div>
                        <div className="row__item">
                            {data.billing_company || '-'}<br />
                            {data.billing_first_name} {data.billing_last_name}<br />
                            {data.phone}<br />
                            {data.email}
                        </div>
                        <div className="row__item row__item--address">
                            {data.billing_street}<br />
                            {data.billing_city_plz} {data.billing_city_name}<br />
                            Deutschland
                        </div>
                    </div>

                    <div className="items__row">
                        <div className="row__title">Lieferaddresse</div>
                        <div className="row__item">
                            {data.shipping_company}<br />
                            {data.shipping_first_name} {data.shipping_last_name}<br />
                            {data.phone}<br />
                            {data.email}
                        </div>
                        <div className="row__item row__item--address">
                            {data.shipping_street}<br />
                            {data.shipping_city_plz} {data.shipping_city_name}<br />
                            Deutschland
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./static/app/checkout/preview/checkoutPreviewAddress.jsx